/**
 * Endereços antigos das consultas de cadastros corporativos no FP&A (ADR 0049, decisão M1). Essas
 * telas saíram do menu do FP&A: o endereço antigo só leva à tela oficial de Dados Mestres, que
 * confere as mesmas permissões de sempre. Nenhuma tela, cadastro ou permissão é duplicado.
 */
export const FPA_MASTER_DATA_REDIRECTS = [
  { from: '/fpa/settings/organization', to: '/legal-entities' },
  { from: '/fpa/settings/organization/companies', to: '/legal-entities' },
  { from: '/fpa/settings/organization/business-units', to: '/structure/business-units' },
  { from: '/fpa/settings/organization/departments', to: '/departments' },
  { from: '/fpa/settings/cost-centers', to: '/governance/cost-centers' },
  { from: '/fpa/settings/classifications', to: '/structure/classifications/TIPO-GASTO' },
  { from: '/fpa/settings/currencies', to: '/currencies' },
] as const;

/** Uma tabela de classificação aberta pela categoria: a mesma categoria em Dados Mestres. */
export const FPA_CLASSIFICATION_REDIRECT = {
  from: '/fpa/settings/classifications/$category',
  to: '/structure/classifications/$category',
} as const;
